import mobile from "mobileBridge";
import styles from "./index.module.css";
import { useTranslation } from "react-i18next";

export default function USTerms() {
  const { t } = useTranslation();
  return (
    <div
      className="WordSection1"
      style={{
        margin: "50px",
        maxWidth: "600px",
        margin: "auto",
        textAlign: "justify",
        lineHeight: "1em",
        padding: "10px",
      }}
    >
      <p
        className="MsoNormal"
        align="center"
        style={{
          marginBottom: "1.75pt",
          textAlign: "center",
          lineHeight: "214%",
        }}
      >
        <b>
          <span className={styles.header}>{t("Terms and Conditions")}</span>
        </b>
      </p>
      <p className="MsoNormal" align="center">
        <span className={styles.subHeader}>
          {t("Agreement to use Website")} <br />
          {t("and")} <br /> {t("Dreambuilders Membership Terms & Conditions")}
        </span>
      </p>
      <div style={{ fontSize: "13px", fontWeight: "300" }}>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.6pt",
            marginLeft: ".5pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Welcome to Dreambuilders Membership, a Delaware LLC")}&nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.3pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            1.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Purpose of This Website and Mobile app")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.5pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("This website and associated mobile application's purpose")}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.3pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            2.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Disclosure")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.6pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Dreambuilders Membership is affiliated with World Wide Group™, LLC"
            )}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.25pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            3.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Definition of Service Plans")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.5pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <i>
            <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
              {t("Basic Member:")}
            </span>
          </i>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {" "}
            {t("A WW affiliated IBO (Basic)")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.35pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <i>
            <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
              {t("Premier Member:")}
            </span>
          </i>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {" "}
            {t("A WW affiliated IBO (Premier)")}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <i>
            <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
              {t("Commissions Paid to Upline:")}
            </span>
          </i>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            &nbsp;
            {t(
              "Specific commissions have been designated for each Premier Membership month"
            )}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.15pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            4.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Online Conduct")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.6pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("The wwdb.com website may only be used for lawful purposes")}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.2pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            5.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Proprietary Property of Dreambuilders Membership")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.6pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Should Dreambuilders Membership acquire or register any trademarks"
            )}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "0in",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            6.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Website Content")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "0in",
            marginLeft: ".5pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.6pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "You acknowledge that the wwdb.com website contains proprietary content"
            )}
            &nbsp;&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.15pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            7.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Conditions for Premier Member Purchase")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.45pt",
            marginLeft: "35.75pt",
            textAlign: "justify",
            textJustify: "inter-ideograph",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Pursuant to the Enhanced Amway Promise Program")}&nbsp;&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.45pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Purchase of Business Materials as Premier")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.45pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "For Complimentary IBOs only, during the Complimentary Membership period, membership will be canceled"
            )}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.45pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Upon cancelation due to inactivity, your Topics data will be cleared"
            )}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.45pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("By registering as a Premier Member")}&nbsp;
          </span>
          <span className="MsoHyperlink">
            <span style={{ fontFamily: '"Open Sans",serif' }}>
              www.amway.com/support/ordering-product-support/rules-of-conduct
            </span>
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "It is agreed that, for the purposes of compliance with the Amway™ Rules of Conduct"
            )}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "normal",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            o
          </span>
          <span
            style={{
              fontSize: "10.0pt",
              fontFamily: '"Arial",sans-serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            7.1.2.3.&nbsp;{t("Except as otherwise provided in Rule 7.1")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.3pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            8.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Conditions for Resale of Business Support Materials")}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.55pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Although a suggested retail price is provided")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.15pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            9.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Termination of Use")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.6pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "You may terminate the services provided by this registration prior to the end of the month"
            )}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.15pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            10.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Security of Your Username and Password")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.6pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "You are responsible for keeping such username and account password confidential"
            )}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.6pt",
            marginLeft: ".25in",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            11.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("When Do We Share Information")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.6pt",
            marginLeft: "36.5pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("We may share information in situations")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.6pt",
            marginLeft: "36.5pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Vendors, Consultants, and Other Third-Party Service Providers")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.6pt",
            marginLeft: "36.5pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("In addition to the third parties listed below")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.6pt",
            marginLeft: "36.5pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("The third parties we may share info with")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "0in",
            marginLeft: "74.75pt",
            textIndent: "-.25in",
          }}
        >
          <span style={{ fontFamily: "Symbol", color: "black" }}>·</span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "116%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <b>
            <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
              {t("Content Optimization")}
            </span>
          </b>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "0in",
            marginLeft: "1.0in",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            Amway™
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "0in",
            marginLeft: "74.75pt",
            textIndent: "-.25in",
          }}
        >
          <span style={{ fontFamily: "Symbol", color: "black" }}>·</span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "116%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <b>
            <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
              {t("Data Backup and Security")}
            </span>
          </b>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "0in",
            marginLeft: "1.0in",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            Amway™
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "0in",
            marginLeft: "74.75pt",
            textIndent: "-.25in",
          }}
        >
          <span style={{ fontFamily: "Symbol", color: "black" }}>·</span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "116%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <b>
            <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
              {t("Functionality and Infrastructure Optimization")}
            </span>
          </b>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "0in",
            marginLeft: "38.75pt",
            textIndent: "33.25pt",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            Amway™
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "0in",
            marginLeft: "74.75pt",
            textIndent: "-.25in",
          }}
        >
          <span style={{ fontFamily: "Symbol", color: "black" }}>·</span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "116%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <b>
            <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
              {t("User Account Registration and Authentication")}
            </span>
          </b>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "0in",
            marginLeft: "72.5pt",
            textIndent: "-.5pt",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            Amway™
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "0in",
            marginLeft: "74.75pt",
            textIndent: "-.25in",
          }}
        >
          <span style={{ fontFamily: "Symbol", color: "black" }}>·</span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "116%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <b>
            <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
              {t("Web and Mobile Analytics")}
            </span>
          </b>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "13.6pt",
            marginLeft: "1.0in",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            Amway™
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.3pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            12.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Disclaimer of Warranties")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.6pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "There are no warranties expressed or implied offered by Dreambuilders Membership"
            )}{" "}
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.3pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            13.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Limitation of Liability")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.55pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Under no circumstances shall Dreambuilders Membership")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.3pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            14.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Applicable Law Jurisdiction")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.6pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Except to the extent the Federal Arbitration Act applies to the Dispute Resolution procedures"
            )}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            15.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Dispute Resolution")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: ".5pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.55pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "All disputes, claims, or controversies arising out of or related to this Agreement"
            )}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "1.35pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            o
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            11.5.7.{" "}
            <i>{t("Arbitrability Issues to Be Decided By Arbitrator")}</i>
            &nbsp;
            {t(
              "The Arbitrator, and not any federal, state, or local court or agency"
            )}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            o
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            11.5.8. <i>{t("Award")}</i>{" "}
            {t("The Arbitrator's award shall be limited")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "0in",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            o
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            11.5.9. <i>{t("Consolidation")}</i>{" "}
            {t("Similar claims involving multiple Parties")}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.45pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            o
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            11.5.10. <i>{t("Discovery")}</i>{" "}
            {t("Notwithstanding any discovery provisions in the JAMS or AAA")}{" "}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "13.6pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "102%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("This dispute resolution agreement")}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "13.6pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "102%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("The parties, when involved in the dispute resolution process")}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            o
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("The substance of the claim")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            o
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("The content of any testimony")}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            o
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("The resolution of any matter of the dispute")}.&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: ".5pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "13.6pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "102%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "nothing in this Agreement shall preclude a party or other signatory"
            )}
            &nbsp;
          </span>
          <span className="MsoHyperlink">
            <span style={{ fontFamily: '"Open Sans",serif' }}>
              www.amway.com
            </span>
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            &nbsp;{t("contained with your copy of the Amway Rules")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.15pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            16.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Indemnification")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.6pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "By use of this website, including the request for services offered"
            )}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.15pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            17.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Modification and Severability")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.65pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Dreambuilders Membership reserves the right to modify")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.3pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            18.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("DreamStream User Agreement")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.6pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "DreamStream is a part of the World Wide Group Dreambuilders Membership"
            )}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoListParagraph"
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "0in",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: "Symbol", color: "black" }}>
            o
            <span style={{ font: '7.0pt "Open Sans"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {"Your Obligations"}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            ▪
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            18.1.1. &nbsp;
            {t("All material you post on DreamStream must comply")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            ▪
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "DreamStream is a platform in which business building and motivational content can be shared"
            )}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            ▪
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            18.1.3. &nbsp;
            {t(
              "Any complaints regarding content posted on DreamStream"
            )}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            ▪
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("It is Management Team policy")}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            ▪
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            18.1.5. &nbsp;{t("Do not abuse DreamStream")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            ▪
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            18.1.6. &nbsp;
            {t(
              "You are solely responsible for all content you post on DreamStream"
            )}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            o
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            18.2. <i>{t("Indemnification")}</i>: &nbsp;
            {t("You indemnify us and hold us harmless")}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            o
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            18.3. <i>{t("Applications")} </i>
            {t(
              "Dreambuilders Membership may offer services through applications"
            )}
            <i>.</i> {t("importing any of your Dreambuilders Membership data")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            o
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            18.4. <i>{t("Privacy:")}</i>
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            ▪
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            18.4.1.&nbsp;{t("You acknowledge of submitting content")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            ▪
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            18.4.2.&nbsp;{"We collect information"}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "2.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("When you register with Dreambuilder")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "2.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("When you view WWG Web pages")}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "2.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Through cookies and other tech")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "2.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("When you interact with third-party services")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            ▪
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            18.4.3.&nbsp;{t("We use the information you provide to")}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "2.25in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Administer your account with us")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "2.25in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Send you service through email")}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.55pt",
            marginLeft: "108.5pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.55pt",
            marginLeft: "1.25in",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("We")}&nbsp;{t("DO NOT")}&nbsp;
            {t("sell, rent, or otherwise provide personally identifiable info")}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            ▪
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            18.4.4.&nbsp;{t("Your information choices are to")}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "2.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Review, enhance, or edit your information")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "2.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Control the messages you receive")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "2.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Change your settings to control visibility")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "2.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("To update your privacy settings")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            ▪
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            18.4.5.&nbsp;{t("Security")}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "2.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Personal information you provide will be secured")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "2.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "You are responsible for maintaining the secrecy of your password and info"
            )}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            ▪
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            18.4.6.<i>&nbsp;{t("Export Control")}</i>
            {t(
              "Your use of Dreambuilders Membership services is subject to export and re-export"
            )}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.25in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            o
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            18.5.<i>&nbsp;{t("Your Rights")}</i>&nbsp;
            {t(
              "On the condition that you comply with all of your obligations under this Agreement"
            )}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.25in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            o
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            18.6.&nbsp;{t("Our Rights and Obligations")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.75in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            ▪
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            18.6.1.<i>&nbsp;{t("Services Availability")}</i>:&nbsp;
            {t(
              "For as long as Dreambuilders Membership continues to offer the services"
            )}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.75in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            ▪
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            18.6.2.<i>&nbsp;{t("Disclosure of User Information")}</i>
            {t(
              "You acknowledge, consent, and agree that we may access, preserve, and disclose your registration"
            )}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.75in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            ▪
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            18.6.3.
            <i>&nbsp;{t("Connections and Interactions With Other Users")}</i>:
            {t(
              "You are solely responsible for your interactions with other users"
            )}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.25in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            o
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            18.7.<i>&nbsp;{t("Disclaimer")}</i>
            &nbsp;
            {t(
              "Do not rely on DreamStream, any information therein, or its continuation"
            )}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.25in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            o
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            18.8.<i>&nbsp;{t("Limitation of Liability")}</i>
            <b>&nbsp;</b>
            {t(
              "Some countries do not allow the limitation or exclusion of liability"
            )}
            &nbsp;
            {t("Neither Dreambuilders Membership nor any of our subsidiaries")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.75in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            ▪
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Apply regardless of whether")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.75in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            ▪
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Not apply to any damage that Dreambuilders Membership may cause you intentionally"
            )}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.75in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            ▪
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Not apply if you have entered into a separate agreement to purchase premium services"
            )}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.25in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            o
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            18.9.&nbsp;{t("Termination")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.75in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            ▪
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            18.9.1.<i>&nbsp;{t("Mutual Rights of Termination")}</i>:&nbsp;
            {t("You may terminate this Agreement, for any or no reason")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.75in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            ▪
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            18.9.2.<i>&nbsp;{t("Misuse of the Services")}</i>:&nbsp;
            {t(
              "Dreambuilders Membership may restrict, suspend, or terminate the account"
            )}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.25in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            o
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            18.10.&nbsp;{t("Dispute Resolution")}&nbsp;
            {t(
              "The Dispute Resolution procedures and terms contained in Section 15"
            )}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.25in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            o
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("DreamStream User Dos and Don'ts")}&nbsp;
            {t("As a condition to access DreamStream")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.75in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            ▪
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            18.11.1.
            <i>
              &nbsp;<b>{t("Do")}</b>&nbsp;{t("undertake the following")}
            </i>
            :
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "156.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Comply with all applicable laws")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "156.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Provide accurate information")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "156.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Review and comply with notices")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "156.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Use the services in a professional manner")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.75in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            ▪
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            18.11.2.
            <b>
              <i>&nbsp;{t("Do not")}</i>
            </b>
            <i>&nbsp;{t("undertake the following")}</i>:
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "156.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Act dishonestly or unprofessionally")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "156.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Harass, abuse, or harm another person")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "156.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Upload a profile image that is not your likeness or a head-shot photo"
            )}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "156.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Upload, post, email, InMail, transmit")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "192.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            1.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Falsely states, impersonates, or otherwise misrepresents your identity"
            )}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "192.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            2.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Is unlawful, libelous, abusive")}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "192.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            3.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Adds to a content field content that is not intended for such field"
            )}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "192.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            4.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Includes information that you do not have the right to disclose"
            )}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "192.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            5.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Infringes upon patents, trademarks")}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "192.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            6.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Includes any unsolicited or unauthorized advertising, promotional materials"
            )}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "192.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            7.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Contains software viruses, worms, or any other computer code, files, programs that interrupt"
            )}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "192.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            8.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Forges headers or otherwise manipulates identifiers")}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "156.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Duplicate, license, sublicense, publish, broadcast")}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "156.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Utilize or copy information, content, or any data you view")}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "156.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Adapt, modify, or create derivative works")}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "156.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Rent, lease, loan, trade, sell/re-sell")}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "156.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Sell, sponsor, or otherwise monetize a DreamStream group")}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "156.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Deep-link to the World Wide Group site for any purpose")}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "156.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Remove any copyright, trademark, or other proprietary rights notices"
            )}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "156.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Collect, use, copy, or transfer any information")}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "156.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Share information of non-users")}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "156.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Use manual or automated software, devices, scripts robots")}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "156.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Use bots or other automated methods to access the World Wide Group website"
            )}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "156.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Access, via automated or manual means or processes, World Wide Group's website"
            )}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "156.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Engage in 'framing', 'mirroring'")}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "156.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Attempt to or actually access the World Wide Group website")}{" "}
          </span>
          <span className="MsoHyperlink">
            <span style={{ fontFamily: '"Open Sans",serif' }}>
              www.wwdb.com
            </span>
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {" "}
            {t(
              "This prohibition includes accessing or attempting to access the World Wide Group website"
            )}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "156.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Attempt to or actually override any security component")}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "156.0pt",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            •
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Engage in any action that directly or indirectly interferes with the proper working"
            )}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: ".5pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.3pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            19.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Modifications and Severability")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.6pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Dreambuilders Membership reserves the right to modify from time to time and without prior notice"
            )}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.6pt",
            marginLeft: ".25in",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            20.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Notice to Residents of the State of California")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: ".25pt",
            marginLeft: ".5in",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("This section supplements the remainder of this Privacy Policy")}
          </span>
        </p>
        <p
          className="MsoListParagraphCxSpFirst"
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "0in",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: "Symbol", color: "black" }}>
            o
            <span style={{ font: '7.0pt "Open Sans"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            20.1.<i>{t("Rights of California Residents Under the CCPA")} </i>
            {t(
              "We will honor verified requests to exercise the rights the CCPA provides to California Residents"
            )}
          </span>
        </p>
        <p
          className="MsoListParagraphCxSpMiddle"
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "0in",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: "Symbol", color: "black" }}>
            o
            <span style={{ font: '7.0pt "Open Sans"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            20.2.
            <i>{t("California Residents")} </i>
            {t(
              "California Residents can exercise their rights under the CCPA"
            )}{" "}
          </span>
          <a href="mailto:support@wwdb.com">
            <span
              style={{
                fontFamily: '"Open Sans",serif',
                color: "#0563C1",
              }}
            >
              support@wwdb.com
            </span>
          </a>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Please provide sufficient detail to us in any such communication"
            )}
          </span>
        </p>
        <p
          className="MsoListParagraphCxSpLast"
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "0in",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: "Symbol", color: "black" }}>
            o
            <span style={{ font: '7.0pt "Open Sans"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            20.3.
            <i>{t("Identity Verification CCPA:")} </i>
            {t(
              "We will require a California Resident to verify their identity before proceeding with a request as described above"
            )}
          </span>
        </p>
        <h1
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "11.3pt",
            marginLeft: "120.1pt",
            lineHeight: "120%",
          }}
        >
          <b>
            <span
              style={{
                fontSize: "13.5pt",
                lineHeight: "120%",
                fontFamily: '"Open Sans",serif',
                color: "black",
              }}
            >
              &nbsp;
            </span>
          </b>
        </h1>
        <h1
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "11.3pt",

            lineHeight: "120%",
          }}
        >
          <b>
            <span className={styles.subHeader}>
              {t("Terms & Conditions of Digital Delivery")}{" "}
            </span>
          </b>
        </h1>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "10.7pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "124%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            1.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "124%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Definitions")}
            <i> </i>&nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "13.6pt",
            marginLeft: ".5in",
            lineHeight: "125%",
          }}
        >
          <i>
            <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
              {t("Publications")}
            </span>
          </i>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {" "}
            {t("a division of Dreambuilders Membership")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.15pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            2.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("System Requirements")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "13.6pt",
            marginLeft: ".5in",
            textIndent: "-.7pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Use of the Service requires one or more compatible devices, Internet access"
            )}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            3.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Policies and Usage Rules")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            o
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            3.1.&nbsp;{t("Your use of the Products")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            o
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            3.2.&nbsp;{t("You shall be authorized")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            o
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            3.3.&nbsp;
            {t(
              "Any exporting capabilities are solely an accommodation to you and shall not constitute a grant or waiver"
            )}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            o
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "You agree that you will not attempt to, or encourage or assist any other person to"
            )}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            o
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("The delivery of Products")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span
            style={{
              fontSize: "10.0pt",
              lineHeight: "104%",
              fontFamily: '"Courier New"',
              color: "black",
            }}
          >
            o
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            3.6.&nbsp;{t("General compliance with laws")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: ".5pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.3pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            4.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Privacy and Security")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.35pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "As a registered user of the Service, you may receive or establish an account"
            )}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.6pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "You understand that the Service, and products transacted through the Service may include a security framework"
            )}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.15pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            5.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Payment")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "You agree to provide accurate, current, and complete information required to register with the Service"
            )}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoListParagraph"
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "0in",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: "Symbol", color: "black" }}>
            o
            <span style={{ font: '7.0pt "Open Sans"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            5.1.
            <i>{t("First Contract Year")} </i>
            {t("Pursuant to the Enhanced Amway Promise Program (“EAP”)")}
            &nbsp;&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Courier New"', color: "black" }}>o</span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            5.2 <i>{t("Payment for Products:")} </i>
            {t(
              "Access to this service is provided based on a monthly subscription fee to be billed on the first of each month"
            )}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Courier New"', color: "black" }}>o</span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            5.3.{" "}
            <i>{t("Right to Change Prices and Availability of Products")} </i>
            {t(
              "Prices and availability of any Products are subject to change at any time"
            )}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".2pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "99%",
          }}
        >
          <span style={{ fontFamily: '"Courier New"', color: "black" }}>o</span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "99%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            5.4. <i>{t("Electronic Signatures and Contracts")} </i>
            {t(
              "Your use of the Service includes the ability to enter into agreements and/or to make transactions electronically"
            )}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Courier New"', color: "black" }}>o</span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("In order to access and retain your electronic records")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "1.55pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Courier New"', color: "black" }}>o</span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Charges to your credit card")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "1.55pt",
            marginLeft: ".5in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.15pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            6.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Automatic Delivery")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.45pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("You are signing up for Digital Delivery")}&nbsp;&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            7.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Refunds")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: ".5pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Business Support Materials are not covered under the Amway Satisfaction Guarantee"
            )}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.2pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Dreambuilders Membership to buy back any Business Support Materials"
            )}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: "0in",
            marginBottom: "16.2pt",
            marginLeft: "35.25pt",
            lineHeight: "normal",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("You must directly contact Dreambuilders for refund")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.6pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Log into the Dreambuilders Membership website and click on the tab in the main menu"
            )}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.35pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("With this Agreement, you are signed up for")}
            <i>{t("Digital Delivery")}</i>
            {t(
              "All new Digital Delivery items will be made available for download"
            )}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            8.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Intellectual Property")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Courier New"', color: "black" }}>o</span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            8.1. <i>{t("Acknowledgement of Ownership")} </i>
            {t(
              "You agree that the Service, including but not limited to products, graphics, audio clips, video clips"
            )}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".2pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "99%",
          }}
        >
          <span style={{ fontFamily: '"Courier New"', color: "black" }}>o</span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "99%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            8.2. <i>{t("Copyrights")}</i>
            {t("The use of the software or any part of the service")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Courier New"', color: "black" }}>o</span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            8.3. <i>{t("Trademarks")}</i>
            {t(
              "Publications, Dreambuilders Membership, LLC, and the logos used in connection with the Service are trademarks"
            )}
            .&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            9.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Termination")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Courier New"', color: "black" }}>o</span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            9.1. <i>{t("Termination by Dreambuilders Membership, LLC")} </i>
            {t(
              "If you fail, or Dreambuilders Membership, LLC, suspects that you have failed, to comply with any of the provisions of this Agreement"
            )}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Courier New"', color: "black" }}>o</span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            9.2. <i>{t("Termination of the Service")} </i>
            {t(
              "Dreambuilders Membership, LLC, reserves the right to modify, suspend, or discontinue the Service"
            )}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            10.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Disclaimers and Liability Limitations")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Courier New"', color: "black" }}>o</span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Dreambuilders Membership, LLC, does not guarantee, represent, or warrant that your use of the service will be uninterrupted"
            )}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Courier New"', color: "black" }}>o</span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "You expressly agree that your use of, or inability to use, the service is at your sole risk"
            )}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Courier New"', color: "black" }}>o</span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "In no case shall Dreambuilders Membership, LLC, its directors, officers, employees, affiliates, agents, contractors, or licensors be liable"
            )}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: "5.05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("exclusion or the limitation of liability for consequential")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Courier New"', color: "black" }}>o</span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Dreambuilders Membership, LLC, shall use reasonable efforts to protect information submitted by you"
            )}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Courier New"', color: "black" }}>o</span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Dreambuilders Membership, LLC, does not represent or guarantee that the service will be free from loss, corruption"
            )}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Courier New"', color: "black" }}>o</span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "There are no warranties expressed, implied, or offered by Dreambuilders Membership"
            )}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Courier New"', color: "black" }}>o</span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Goods sold by Dreambuilders Membershipare sold with a disclaimer"
            )}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: "1.0in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Courier New"', color: "black" }}>o</span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;&nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Certain state laws do not allow limitations on implied warranties"
            )}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: ".5pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.15pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            11.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Waivers and Indemnity")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.6pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "You agree to indemnify and hold harmless Diamond Publications, Dreambuilders Membership, LLC, its parent company, World Wide Group, LLC, and all its affiliates"
            )}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            12.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Applicable Law and Jurisdiction")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: ".25pt",
            marginLeft: ".5pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            &nbsp;
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.6pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("The Terms and Conditions of the use of this website")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "15.5pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            13.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Dispute Resolution")}{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "15.5pt",
            marginLeft: "31.5pt",
            textIndent: "-4.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            &nbsp; {t("See Section 15 of Agreement to Use")}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.3pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            14.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Changes to This Agreement")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.5pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Dreambuilders Membership, LLC, reserves the right, at any time and from time to time, to update, revise, supplement, and otherwise modify this Agreement"
            )}
            &nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "13.3pt",
            marginLeft: ".5in",
            textIndent: "-.25in",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            15.
          </span>
          <span
            style={{
              fontSize: "7.0pt",
              lineHeight: "104%",
              fontFamily: '"Open Sans",serif',
              color: "black",
            }}
          >
            &nbsp;{" "}
          </span>
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t("Modifications and Severability")}&nbsp;{" "}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "0in",
            marginRight: ".05pt",
            marginBottom: "19.0pt",
            marginLeft: "35.75pt",
            textIndent: "-.5pt",
            lineHeight: "104%",
          }}
        >
          <span style={{ fontFamily: '"Open Sans",serif', color: "black" }}>
            {t(
              "Dreambuilders Membership reserves the right to modify from time to time and without prior notice the T&C"
            )}
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: "13.5pt",
            width: "100%",
            textAlign: "center",
          }}
        >
          <div className={styles.header}>
            {t("Do you agree to these Terms and Conditions")}
          </div>
        </p>
      </div>
    </div>
  );
}
